export default {"src":"/_next/static/media/youtube.6650b716.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};